import { type ReactNode, forwardRef } from 'react'
import * as BaseScrollArea from '@radix-ui/react-scroll-area'

interface ScrollAreaProps {
  children: ReactNode
  className?: string
  side?: 'left' | 'right'
}

const VerticalScrollArea = forwardRef<HTMLDivElement, ScrollAreaProps>(
  ({ children, className = '', side = 'right' }, ref) => {
    const combinedClassName = `v-scroll-area ${className}`

    return (
      <BaseScrollArea.Root
        className={combinedClassName}
        dir={side === 'left' ? 'rtl' : 'ltr'}
      >
        <BaseScrollArea.Viewport className="viewport" ref={ref}>
          <div dir="ltr">{children}</div>
        </BaseScrollArea.Viewport>
        <BaseScrollArea.Scrollbar className="scrollbar" orientation="vertical">
          <BaseScrollArea.Thumb className="thumb" />
        </BaseScrollArea.Scrollbar>
        <BaseScrollArea.Corner />
      </BaseScrollArea.Root>
    )
  }
)

VerticalScrollArea.displayName = 'VerticalScrollArea'

export default VerticalScrollArea
